import { IonContent, IonIcon, IonListHeader, IonItem, IonLabel, IonList, IonMenu } from '@ionic/react'
import { authContext } from 'contexts/'
import { icon_calendar, icon_logout, icon_profile } from 'icons'
import { useContext, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './profile-menu.scss'
import { keyOutline } from 'ionicons/icons'
import { Link } from 'react-router-dom'

const ProfileMenu: React.FC = () => {
  const auth = useContext(authContext)

  const { t } = useTranslation()
  const menuRef = useRef<HTMLIonMenuElement | null>(null)

  const onClickLogout = () => {
    menuRef?.current?.close(true)
    auth?.logout(() => {})
  }

  if (!auth?.user) {
    return <></>
  }

  const toggle = () => {
    menuRef?.current?.toggle()
  }

  return (
    <IonMenu type="overlay" contentId="main-content-id" side="start" ref={menuRef}>
      <IonContent className="ion-no-padding edisu-profile-menu-content">
        <IonList>
          <IonListHeader lines="none" className="header">
            <IonLabel position="stacked" className="edisu-label ion-text-uppercase">
              {t('user')}
            </IonLabel>
            <IonLabel>
              {auth?.user?.nome} {auth?.user?.cognome}
            </IonLabel>
          </IonListHeader>
          <Link to={'/modify-profile'} onClick={toggle}>
            <IonItem lines="none" className="dropdown-item with-margin-top ion-text-uppercase">
              <IonIcon icon={icon_profile} slot="start" />
              <IonLabel> {t('profile')}</IonLabel>
            </IonItem>
          </Link>
          <Link to={'/update-pw'} onClick={toggle}>
            <IonItem lines="none" className="dropdown-item ion-text-uppercase">
              <IonIcon icon={keyOutline} slot="start" />
              <IonLabel> {t('reset_pw')}</IonLabel>
            </IonItem>
          </Link>
          <Link to={'/booking-history'} onClick={toggle}>
            <IonItem lines="none" className="dropdown-item  with-margin-bottom ion-text-uppercase">
              <IonIcon icon={icon_calendar} slot="start" className="dropdown-item" />
              <IonLabel> {t('my_bookings')}</IonLabel>
            </IonItem>
          </Link>
          <IonItem lines="none" className="dropdown-item ion-text-uppercase clickable" onClick={onClickLogout}>
            <IonIcon icon={icon_logout} slot="start" />
            <IonLabel> {t('logout')}</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonMenu>
  )
}

export default ProfileMenu
